import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateDelegationPermissions } from "../../api/delegation";
import { UpdateDelegationPermissionsModel } from "../../interfaces/delegation";
import { invalidateDelegationQueries } from "./delegationQueryKeys";

export const useUpdateDelegationPermissions = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      id,
      model,
    }: {
      id: string;
      model: UpdateDelegationPermissionsModel;
    }) => updateDelegationPermissions(id, model),
    onSuccess: () => {
      invalidateDelegationQueries(queryClient);
    },
  });
};
